// 姓名由实名认证维护；性别与生日只允许在尚未设置时提交。
export function buildMemberProfileChanges(profile, form) {
  if (!profile) return {}
  const changes = {}
  if ((!profile.gender || profile.gender === 'UNKNOWN') && ['MALE', 'FEMALE'].includes(form.gender)) changes.gender = form.gender
  if (!profile.birthday && form.birthday) changes.birthday = form.birthday
  return changes
}
